 /**
 * v-hasRole 角色权限处理
 */

import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    // const super_admin = "admin";
    const roles = store.getters && store.getters["right/getRole"]
    if (value && value instanceof Array && value.length > 0) {
      const roleFlag = value

      const hasRole = value.some(role => {
        // return super_admin === role || roleFlag.includes(role)

        return role===roles
      })

      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置角色权限标签值"`)
    }
  }
}
function roleFormat(role){
switch (role) {
  case 'MANAGER':role='manager';break;
  case 'SALES':role='saler';break;
  case 'PROJECT':role='project';break;
  case 'ANALYST':role='analyzer';break;
  case 'CUSTOMER':role='customer';break;
}
}

